<template>
	<iframe ref="embedElement" loading="lazy"
			width="100%"
			height="493"
			:src="`https://watchbetter.com/embedPartner/${props.playlist}${props.autoplay ? '?autoplay=1' : ''}#cmpnoscreen`"
			title="watchbetter player"
			frameborder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
			allowfullscreen
			style="max-width: 660px;"/>
</template>

<script setup lang="ts">
const props = defineProps<{
	playlist: string,
	autoplay?: boolean,
}>();
</script>